import { FaHardHat, FaShieldAlt, FaUsers, FaBuilding } from "react-icons/fa";

  const whyChooseUs = {
    sub: "Why Choose Us",
    heading: "Building Excellence with Precision & Quality",
    content: "At BuildX, we are committed to delivering unmatched construction services with a focus on quality, precision, and customer satisfaction.",
    points: [
      {
        id: 1,
        title: "Expert {Craftsmanship}",
        icon: <FaHardHat />,
      },
      {
        id: 2,
        title: "High-Quality {Materials}",
        icon: <FaShieldAlt />,
      },
      {
        id: 3,
        title: "Experienced {Team}",
        icon: <FaUsers />,
      },
      {
        id: 4,
        title: "Comprehensive {Solutions}",
        icon: <FaBuilding />,
      },
    ],
  };
  
  export default whyChooseUs;  